let upsellTail: Promise<void> = Promise.resolve();

export function runUpsellAfterPrevious<T>(task: () => Promise<T>): Promise<T> {
  const next = upsellTail.then(() => task());
  upsellTail = next.then(
    () => undefined,
    () => undefined,
  );
  return next;
}
